<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="airalo_simcard_is_load" parent="airalo_simcard">
    <tab id="info" :name="translate('airalo.section.info')" :href="url+'/info'">
      <AiraloSimcardInfo v-if="airalo_simcard_is_load"
        :airalo_simcard="airalo_simcard_info"
        @update="get_airalo_simcard"
        @update_data="update_data"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Airalo Simcard: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/airalo_list/simcard_list'}">
              To Airalo Simcard list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import AiraloSimcardInfo from './Tabs/Info/Index.vue'

export default {
  name: 'AiraloSimcard',
  components: {
    AiraloSimcardInfo,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      airalo_simcard_info: null,
    }
  },

  computed: {
    url () { return '/airalo_simcard/' + this.$route.params.airalo_simcard_id },
    cur_id () { return this.$route.params.airalo_simcard_id },
    load () { return !this.airalo_simcard_info?.id },
    airalo_simcard_is_load() { return this.airalo_simcard_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'airalo_simcard_section') {
        this.get_airalo_simcard()
      }
    }
  },

  activated(){
    this.get_airalo_simcard()
  },

  methods: {
    update_data(data){
      this.airalo_simcard_info = data
    },
    get_airalo_simcard () {
      this.$http.simcard.getAiraloSimcard(this.$route.params.airalo_simcard_id, (response) => {
        this.airalo_simcard_info = response.data
      })
    }
  }
}

</script>
